class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");

    this.form = this.querySelector("form.localization-form__form");

    this.select.addEventListener("change", () => {
      this.form.submit();
    });
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}
